import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { setTitle } from "modules/common/utils";
import BreadCrumbItem from "./BreadCrumbItem";
import { colors, dimensions } from "../../styles";

const Items = styled.ol`
  display: inline-block;
  padding: 0;
  margin: 0 ${dimensions.coreSpacing}px 0 0;
  list-style: none;
  font-size: 14px;

  a {
    color: ${colors.themeBlack};
    font-weight: 500;
  }

  .disabled {
    cursor: pointer;
  }
`;

const propTypes = {
  breadcrumbs: PropTypes.array.isRequired,
};

class BreadCrumb extends Component {
  setTabTitle() {
    const { __ } = this.context;
    const { breadcrumbs } = this.props;
    // const page = (breadcrumbs && breadcrumbs.pop()) || {};
    const page = (breadcrumbs && breadcrumbs[breadcrumbs.length - 1]) || {};

    // setTitle(
    //   page.title || '',
    //   page.title ? page.useForce || (page.title === 'Inbox' && document.title.startsWith('(1)'))
    //     : ''
    // );
    const pageTitle = page.title || "";

    // Set document title with specific logic for "Inbox"
    const newTitle = pageTitle
      ? `${pageTitle} ${
          page.useForce ||
          (pageTitle === "Inbox" && document.title.startsWith("(1)"))
            ? ""
            : ""
        }`
      : document.title;

    setTitle(newTitle);
  }

  componentDidUpdate() {
    this.setTabTitle();
  }

  componentDidMount() {
    this.setTabTitle();
  }

  render() {
    return (
      <Items role="navigation" aria-label="breadcrumbs">
        {this.props.breadcrumbs.map((b) => (
          <BreadCrumbItem
            className={
              !b.link || window.location.pathname === b.link ? "disabled" : ""
            }
            to={b.link}
            active={b.link && window.location.pathname !== b.link}
            key={b.title}
          >
            {b.title}
          </BreadCrumbItem>
        ))}
      </Items>
    );
  }
}

BreadCrumb.propTypes = propTypes;
BreadCrumb.contextTypes = {
  __: PropTypes.func,
};

export default BreadCrumb;



// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/breadcrumb/BreadCrumb.js